import 'client-only';

import { type WinbackPromotion } from '@/components/flow/steps/resubscription-checkout/utils/types';
import { type Brand } from '@/consts/brands';
import { get } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const getWinbackPromotion = async (brand: Brand) =>
  get<{ promotion: WinbackPromotion }>(
    urls[brand].api.promotion.getWinbackPromotion,
  );

export const PromotionService = {
  getWinbackPromotion,
};
